<template>
	<div class="head">
	    <span style="margin-bottom:.3rem">云东畜牧大数据平台</span>
		<div class="back" @click="goBack" v-if='back'>
			<img class="icon" src="@/assets/yq/back.png" alt="">
			<span class="title">返回上一层</span>
		</div>
	</div>
	
</template>

<script>
	export default {

		props: {
			back:{
				type:Boolean,
				default:true
			}
			

		},
		data() {
			return {
				
			};
		},
		async created() {

		},

		methods: {

			goBack(){
				this.$router.go(-1)
			}

		},
	};
</script>
<style lang="scss" scoped>
	.head {
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    width: 100%;
	    height: 1.2rem;
	    background: url('../../../assets/yq/headbg.png');
	    background-size: 100% 100%;
	    font-size: 0.55rem;
	    font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
	    font-weight: 700;
	    color: #19ECFF;
	    letter-spacing: 5px;
		position: relative;
	}
	.back:focus, .back:hover{
		transform: scale3d(1.1, 1.1, 1.1)
	}
	.back{
		cursor: pointer;
		padding-left: 0.43rem;
		position: absolute;
		bottom: 0	;
		left: 0;
		    display: flex;
		    align-items: center;
		.icon{
			width: 0.38rem;
			height: 0.38rem;
			margin-right: 0.05rem;
		}
		.title{
			font-size: 0.2rem;
			font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
			font-weight: 400;
			color: #19ECFF;
		}
		
	}
</style>